import { render } from "./AppSettingsPage.vue?vue&type=template&id=4e78b1e7&scoped=true"
import script from "./AppSettingsPage.vue?vue&type=script&lang=js"
export * from "./AppSettingsPage.vue?vue&type=script&lang=js"

import "./AppSettingsPage.vue?vue&type=style&index=0&id=4e78b1e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e78b1e7"]])

export default __exports__